<div *ngIf="form" class="w-100 text-center mt-2">
    <form ngNoForm name="frm" [action]="form.url" method="POST" target="_blank">
        <input type="hidden" id="Ds_SignatureVersion" name="Ds_SignatureVersion" [value]="form.body.Ds_SignatureVersion" />
        <input type="hidden" id="Ds_MerchantParameters" name="Ds_MerchantParameters" [value]="form.body.Ds_MerchantParameters" />
        <input type="hidden" id="Ds_Signature" name="Ds_Signature" [value]="form.body.Ds_Signature" />
        <button (click)="reload()" type="submit" class="btn btn-warning fw-bolder text-white text-y-shadow my-3 w-70">Pagar</button>
    </form>
</div>